import React from 'react'

const Neet = () => {
  return (
    <div className='max-w-screen-2xl'>
      
    </div>
  )
}

export default Neet